import React, { Component } from 'react';
import uniqueId from 'react-html-id';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import './Questions.scss';
import { TEXT_FIELD_IS_REQUIRED } from '../../../../utils/messages';
import { TEXT_FIELD_STATUS } from '../../../../utils/constants';

class Questions extends Component {
  static propTypes = {
    getAppQuestions: PropTypes.func.isRequired,
    appQuestions: PropTypes
      .shape({})
      .isRequired,
    isVisible: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes
      .shape({})
      .isRequired,
    registerField: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    appAnswers: PropTypes
      .shape({})
      .isRequired,
  }
  static defaultProps = {
    isVisible: true,
    isRequired: false,
  }

  constructor() {
    super();
    uniqueId.enableUniqueIds(this);
  }

  componentDidMount() {
    const {
      getAppQuestions, name, registerField,
    } = this.props;

    getAppQuestions();
    registerField({ name, validator: this.standardValidator });
  }

  componentDidUpdate(prevProps) {
    const {
      appQuestions, value, name, changeHandler, appAnswers,
    } = this.props;
    if (prevProps.appQuestions !== this.props.appQuestions && !appAnswers) {
      const appQuestionsNames = Object.keys(appQuestions);
      if (appQuestionsNames.length && typeof value[appQuestionsNames[0]] === 'undefined') {
        for (let i = 0; i < appQuestionsNames.length; i += 1) {
          if (!value[appQuestionsNames[i]]) {
            value[appQuestionsNames[i]] = '';
          }
        }
      }
      changeHandler({ value, name });
    }
  }

  standardValidator = (value) => {
    const { isRequired } = this.props;

    let valid = true;
    let errorText = '';

    if (isRequired && !(value && value.length)) {
      valid = false;
      errorText = TEXT_FIELD_IS_REQUIRED;
    }
    const status = valid
      ? TEXT_FIELD_STATUS.VALID
      : TEXT_FIELD_STATUS.INVALID;

    return { status, errorText };
  };

  changeHandler = (e) => {
    const { value, name, changeHandler } = this.props;
    const {
      target: {
        name: localName,
        value: newValue,
      },
    } = e;
    value[localName] = newValue;
    changeHandler({ value, name });
  }

  renderQuestionRow = ({
    firstColumnQuestion, firstColumnQuestionName, secondColumnQuestion, secondColumnQuestionName,
  }) => {
    const hasPair = secondColumnQuestionName;
    const { value } = this.props;
    return (
      <React.Fragment>
        <div key={this.nextUniqueId()} className="question-row">
          <div className="question">
            <span>{firstColumnQuestion}</span>
          </div>
          <div className="question">
            <span>{hasPair && secondColumnQuestion}</span>
          </div>
        </div>
        <div key={this.nextUniqueId()} className="answer-row">
          <div className="answer"><TextareaAutosize
            value={value[firstColumnQuestionName] || ''}
            onChange={this.changeHandler}
            name={firstColumnQuestionName}
            maxRows={6}
            style={{
           resize: 'none',
      }}
            rows={1}
          />
          </div>
          <div className="answer"><TextareaAutosize
            value={value[secondColumnQuestionName] || ''}
            onChange={this.changeHandler}
            maxRows={6}
            name={secondColumnQuestionName}
            style={{
              resize: 'none',
            }}
            rows={1}
          />
          </div>
        </div>
        <div className="line-break" />
      </React.Fragment>
    );
  }

  render() {
    const { appQuestions, isVisible } = this.props;
    const appQuestionNames = Object.keys(appQuestions);
    const questionWrapperClasses = classNames({ 'questions-wrapper': true, 'visible-question-wrapper': isVisible });

    const questionsForRender = appQuestionNames.filter((questionName, i) => {
      if (i % 2 === 0) {
        return true;
      }
      return false;
    }).map((questionName) => {
      const realIndex = appQuestionNames.indexOf(questionName);
      const result = {
        firstColumnQuestionName: appQuestionNames[realIndex],
        firstColumnQuestion: appQuestions[appQuestionNames[realIndex]],
      };

      const hasPair = appQuestionNames[realIndex + 1];
      if (hasPair) {
        result.secondColumnQuestionName = hasPair;
        result.secondColumnQuestion = appQuestions[hasPair];
      }
      return result;
    });
    return (
      <div className={questionWrapperClasses}>
        {appQuestionNames.length
          ? questionsForRender.map(questionPair => this.renderQuestionRow(questionPair))
          : null}
      </div>
    );
  }
}

export default Questions;



// WEBPACK FOOTER //
// ./src/containers/CreateApp/components/Questions/Questions.js